import template from './template.html';

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('notfound', {
        parent: 'guest',
        template: template,
        url: 'notfound'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/guest/notfound/index.js